import './form_component.scss'
import { Controller } from 'stimulus'

export default class extends Controller {
  connect = (): void => {
    this.remote = !!this.inLayover
  }

  get inLayover (): boolean {
    return this.element.closest('.layover') !== null
  }

  get remote (): boolean {
    return this.element.dataset.remote === 'true'
  }

  set remote (value: boolean) {
    this.element.dataset.remote = value
  }
}
